"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryTransport = void 0;
const transport_1 = require("../transport");
class InMemoryTransport extends transport_1.Transport {
    constructor() {
        super(...arguments);
        this.others = new Set();
        this.connect = (transport) => {
            this.others.add(transport);
        };
        this.disconnect = (transport) => {
            this.others.delete(transport);
        };
    }
    send(message) {
        for (const transport of this.others) {
            transport.emit('message', message);
        }
    }
}
exports.InMemoryTransport = InMemoryTransport;
//# sourceMappingURL=in-memory.js.map